var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diamond",class:{ 'diamond--active': _vm.isActive, 'diamond--static': _vm.staticType },style:({
        background: `linear-gradient(90deg, ${_vm.color} 50%, ${_vm.secondaryColor ? _vm.secondaryColor : _vm.color} 50%)`,
        outline: _vm.hasWhiteColor ? '1px solid #c5bbb9' : '',
    })})
}
var staticRenderFns = []

export { render, staticRenderFns }